<form [formGroup]="groupCreateForm" (ngSubmit)="createGroup()" class="form-horizontal form-material"
  id="groupCreateForm" novalidate>
  <div class="modal-header">
    <h4 class="modal-title">{{groupData?'Update':'Create'}} Group</h4>
  </div>
  <div class="modal-body">
    <div class="form-group row">
      <label class="col-12 col-xl-2">
        <app-required-indication [control]="groupCreateForm.controls['name']" [label]="'Primary Dealer'">
        </app-required-indication>
      </label>
      <div class="col-12 col-xl-4">
        <app-form-error-wrapper [apiErrorType]="'name'" [control]="groupCreateForm.controls['name']"
          [controlName]="'Group name'">
          <input class="form-control" type="text" formControlName="name" />
        </app-form-error-wrapper>
      </div>
      <label class="col-12 col-xl-2">
        <app-required-indication [control]="groupCreateForm.controls['einNumber']" [label]="'EIN Number'">
        </app-required-indication>
      </label>
      <div class="col-12 col-xl-4">
        <app-form-error-wrapper [apiErrorType]="'einNumber'" [control]="groupCreateForm.controls['einNumber']"
          [controlName]="'EIN Number'">
          <input class="form-control" type="text" mask="AA-AAAAAAA" formControlName="einNumber" />
        </app-form-error-wrapper>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-12 col-xl-2">
        <app-required-indication [control]="groupCreateForm.controls['address']" [label]="'Street Address'">
        </app-required-indication>
      </label>
      <div class="col-12 col-xl-4">
        <app-form-error-wrapper [apiErrorType]="'address'" [control]="groupCreateForm.controls['address']"
          [controlName]="'Street Address'">
          <input class="form-control" type="text" formControlName="address" />
        </app-form-error-wrapper>
      </div>
      <label class="col-12 col-xl-2">
        <app-required-indication [control]="groupCreateForm.controls['zip']" [label]="'Zip Code'">
        </app-required-indication>
      </label>
      <div class="col-12 col-xl-4">
        <app-form-error-wrapper [apiErrorType]="'zip'" [control]="groupCreateForm.controls['zip']"
          [controlName]="'Zip Code'">
          <input class="form-control" type="tel" formControlName="zip" minlength="4" maxlength="5" mask="00000"
            (keyup)="checkZip($event.target.value,'zipCode')" />
        </app-form-error-wrapper>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-12 col-xl-2">
        <app-required-indication [control]="groupCreateForm.controls['city']" [label]="'City'">
        </app-required-indication>
        <app-button-loader *ngIf="zipSpin" [isLoading]="zipSpin"> </app-button-loader>

      </label>
      <div class="col-12 col-xl-4">
        <app-form-error-wrapper [apiErrorType]="'city'" [control]="groupCreateForm.controls['city']"
          [controlName]="'City'">
          <input class="form-control" type="text" formControlName="city" />
        </app-form-error-wrapper>
      </div>
      <label class="col-12 col-xl-2">
        <app-required-indication [control]="groupCreateForm.controls['state']" [label]="'State'">
        </app-required-indication>
        <app-button-loader *ngIf="zipSpin" [isLoading]="zipSpin">
        </app-button-loader>
      </label>
      <div class="col-12 col-xl-4">
        <app-form-error-wrapper [apiErrorType]="'state'" [control]="groupCreateForm.controls['state']"
          [controlName]="'State'">
          <select class="custom-select form-control" formControlName="state">
            <option value="">Select State</option>
            <option *ngFor="let stat of states" value="{{ stat.code }}">{{
              stat.name
              }}</option>
          </select>
        </app-form-error-wrapper>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-12 col-xl-2">
        <app-required-indication [control]="groupCreateForm.controls['phone']" [label]="'Phone Number'">
        </app-required-indication></label>
      <div class="col-12 col-xl-4">
        <app-form-error-wrapper [apiErrorType]="'phone'" [control]="groupCreateForm.controls['phone']"
          [controlName]="'Phone Number'">
          <input class="form-control" type="tel" mask="000-000-0000" formControlName="phone" />
        </app-form-error-wrapper>
      </div>
      <!-- <label class="col-12 col-xl-2">Email</label>
      <div class="col-12 col-xl-4">
        <app-form-error-wrapper
          [apiErrorType]="'email'"
          [control]="groupCreateForm.controls['email']"
          [controlName]="'Email'"
        >
          <input class="form-control" type="email" formControlName="email" />
        </app-form-error-wrapper>
      </div> -->
    </div>
  </div>
  <h3 class="f-500 title-case pl-3">Dealership Locations</h3>
  <div formArrayName="locations" *ngIf="dealerLocation">
    <div *ngFor="let item of dealerLocation.controls; let i = index" class="mt-1">
      <div [formGroupName]="i">
        <hr *ngIf="i !== 0" />
        <div class="form-group d-xl-flex align-items-center mb-0">
          <div class="form-group col-12 col-xl-4 d-xl-flex align-items-center">
            <label class="col-12 col-xl-6 p-0">
              <app-required-indication [control]="item.get('legalName')"
                [label]="'Legal Name of Entity'"></app-required-indication>
            </label>
            <div class="d-flex col-12 col-xl-6 p-0">
              <div class="col-12 p-0">
                <app-form-error-wrapper [control]="item.get('legalName')" [controlName]="'legalName'"
                  [apiErrorType]="'legalName'">
                  <input type="text" name="legalName" formControlName="legalName" class="form-control" />
                </app-form-error-wrapper>
              </div>
            </div>
          </div>
          <div class="form-group col-12 col-xl-3 d-xl-flex align-items-center">
            <label class="col-12 col-xl-4 p-0 text-xl-center">
              <ng-container>
                <app-checkbox [label]="'d/b/a'" [id]="'dbacheck' + i" [name]="'dbacheck' + i"
                  [checked]="item.get('dbacheck').value" (onClick)="dbaCheck(i, $event.target.checked)">
                </app-checkbox>
              </ng-container>
            </label>
            <div class="col-12 col-xl-8 p-0" *ngIf="item.get('dbacheck').value">
              <app-form-error-wrapper [control]="item.get('dba')" [controlName]="'d/b/a'" [apiErrorType]="'dba'">
                <input type="text" name="dba" class="form-control" formControlName="dba" />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group col-12 col-xl-4 d-xl-flex align-items-center">
            <label class="col-12 col-xl-4 p-0 text-xl-center">
              <app-required-indication [control]="item.get('einNumber')" [label]="'EIN'"></app-required-indication>
            </label>
            <div class="col-12 col-xl-8 p-0">
              <app-form-error-wrapper [control]="item.get('einNumber')" [controlName]="'EIN'"
                [apiErrorType]="'einNumber'">
                <input class="form-control" type="text" mask="AA-AAAAAAA" formControlName="einNumber" />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group col-12 col-xl-1 d-xl-flex align-items-center">
            <button type="button" class="btn btn-danger" (click)="removeContact(i)">
              <i class="mdi mdi-close"></i>
            </button>
          </div>
        </div>
        <div class="form-group d-xl-flex align-items-center mb-0">
          <div class="form-group col-12 col-xl-4 d-xl-flex align-items-center">
            <label class="col-12 col-xl-6 p-0">
              <app-required-indication [control]="item.get('address')"
                [label]="'Street Address'"></app-required-indication>
            </label>
            <div class="col-12 col-xl-6 p-0">
              <app-form-error-wrapper [control]="item.get('address')" [controlName]="'Street Address'"
                [apiErrorType]="'address'">
                <input type="text" name="address" class="form-control" formControlName="address" />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group col-12 col-xl-2 d-xl-flex align-items-center">
            <label class="col-12 col-xl-4 p-0 text-xl-center">
              <app-required-indication [control]="item.get('zip')" [label]="'Zip'"></app-required-indication>
            </label>
            <div class="col-12 col-xl-8 p-0">
              <app-form-error-wrapper [control]="item.get('zip')" [controlName]="'Zip'" [apiErrorType]="'zip'">
                <input class="form-control" type="tel" formControlName="zip" minlength="4" maxlength="5" mask="00000"
                  (keyup)="checkLocationZip($event.target.value,i)" />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group col-12 col-xl-3 d-xl-flex align-items-center">
            <label class="col-12 col-xl-4 p-0 text-xl-center">
              <app-required-indication [control]="item.get('city')" [label]="'City'"></app-required-indication>
              <app-button-loader *ngIf="spinZip[i]" [isLoading]="spinZip[i]"> </app-button-loader>
            </label>
            <div class="col-12 col-xl-8 p-0">
              <app-form-error-wrapper [control]="item.get('city')" [controlName]="'City'" [apiErrorType]="'city'">
                <input class="form-control" type="text" formControlName="city" />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group col-12 col-xl-3 d-xl-flex align-items-center">
            <label class="col-12 col-xl-4 p-0 text-xl-center">
              <app-required-indication [control]="item.get('state')" [label]="'State'"></app-required-indication>
              <app-button-loader *ngIf="spinZip[i]" [isLoading]="spinZip[i]"> </app-button-loader>
            </label>
            <div class="col-12 col-xl-8 p-0">
              <app-form-error-wrapper [control]="item.get('state')" [controlName]="'State'" [apiErrorType]="'state'">
                <select class="custom-select form-control" formControlName="state">
                  <option value="">Select State</option>
                  <option *ngFor="let stat of states" value="{{ stat.code }}">{{
                    stat.name
                    }}</option>
                </select>
              </app-form-error-wrapper>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr *ngIf="dealerLocation.length > 0" />
    <div class="form-group d-xl-flex align-items-center" *ngIf="dealerLocation.length <20">
      <label class="col-12 col-xl-2"></label>
      <div class="col-12 col-xl-10">
        <button type="button" class="btn btn-primary" (click)="addContact()">
          <i class="mdi mdi-plus"></i> Add more Location(s)
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">
      Cancel
    </button>
    <button class="btn btn-primary" [disabled]="groupCreateForm.invalid || isLoading">
      <app-button-loader [isLoading]="isLoading" [label]="'Submit'"></app-button-loader>
    </button>
  </div>
</form>
<app-table-loader [isLoading]="isLoading"></app-table-loader>